/**
 * Accès localStorage tolérant aux contextes où le stockage est bloqué : Safari
 * « Bloquer tous les cookies », webviews intégrées, mode privé strict, iframes
 * sandboxées. Dans ces cas, l'accès à `window.localStorage` LUI-MÊME jette un
 * `SecurityError` (pas seulement getItem/setItem). Toutes les opérations échouent
 * silencieusement au lieu de casser le rendu React (cf. Sentry KENOMETRIC-37).
 *
 * À utiliser partout où un accès localStorage peut tourner au montage/rendu.
 */
export const safeStorage = {
  getItem(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      /* stockage bloqué */
    }
  },
  removeItem(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* stockage bloqué */
    }
  },
};
